export default __webpack_public_path__ + "static/media/intro.66618cb4.jpg";